import { emailDigestEnum } from "@repo/fika-db/schema"
import { z } from "zod"
import { baseSchema, schemaToJson } from "../schema-utils.js"

const DbUserSchema = z.strictObject({
  ...baseSchema.shape,
  blog_footer: z.string().nullish(),
  blog_header: z.string().nullish(),
  created_at: z.date().nullable(),
  description: z.string().nullable(),
  email: z.string(),
  email_digest: z.enum(emailDigestEnum).nullable(),
  jwt: z.string().nullable(),
  logo_url: z.string().nullish(),
  name: z.string().nullable(),
  share_bookmarks: z.boolean(),
  title: z.string().nullable(),
  updated_at: z.date().nullish(),
  welcome_image_url: z.string().nullish(),
  wordmark_url: z.string().nullish(),
})
export type DbUser = z.infer<typeof DbUserSchema>

export const UserSchema = schemaToJson(DbUserSchema)
export type User = z.infer<typeof UserSchema>
